










// //   import React, { useState, useEffect, useCallback } from 'react';
// // import api from '../api/api';
// // import {
// //   Upload, Save, AlertCircle, CheckCircle2, RefreshCw,
// //   Users, UserCircle, RotateCcw, Info
// // } from 'lucide-react';

// // const AdminDashboard = () => {
// //   const [spinProducts, setSpinProducts]                 = useState([]);
// //   const [file, setFile]                                 = useState(null);
// //   const [status, setStatus]                             = useState({ msg: '', type: '' });
// //   const [isLoading, setIsLoading]                       = useState(true);
// //   const [cycleStatus, setCycleStatus]                   = useState([]);
// //   const [maleCycleComplete, setMaleCycleComplete]       = useState(false);
// //   const [femaleCycleComplete, setFemaleCycleComplete]   = useState(false);

// //   // Dynamic Cycle Targets
// //   const [maleCycleSize, setMaleCycleSize]               = useState(100);
// //   const [femaleCycleSize, setFemaleCycleSize]           = useState(100);

// //   const fetchCycleStatus = useCallback(async () => {
// //     try {
// //       const res = await api.get('/api/admin/cycle-status');
// //       if (res.data.success) {
// //         setCycleStatus(res.data.data);
// //         setMaleCycleComplete(res.data.maleCycleComplete);
// //         setFemaleCycleComplete(res.data.femaleCycleComplete);

// //         const maleCfg = res.data.data.find(d => d.gender === 'male');
// //         if (maleCfg && maleCfg.cycleSize) setMaleCycleSize(maleCfg.cycleSize);

// //         const femaleCfg = res.data.data.find(d => d.gender === 'female');
// //         if (femaleCfg && femaleCfg.cycleSize) setFemaleCycleSize(femaleCfg.cycleSize);
// //       }
// //     } catch (err) {
// //       console.error('Cycle status error:', err);
// //     }
// //   }, []);

// //   const fetchSpinEnabledProducts = useCallback(async () => {
// //     try {
// //       setIsLoading(true);
// //       const res = await api.get('/api/products');
// //       const active = res.data.filter(p => p.addInSpin === true);

// //       const mapped = active.map(p => {
// //         const cfg = p.discounts?.length ? p.discounts[0] : null;
// //         return {
// //           id          : p.id,
// //           lineItemName: p.lineItemName || '',
// //           category    : p.category    || '',
// //           subCategory : p.subCategory || '',
// //           label       : cfg ? cfg.label     : '',
// //           winWeight   : cfg ? cfg.winWeight : '0',
// //           isActive    : p.isActive,
// //           gender      : (p.gender || 'male').toLowerCase(),
// //           cycleSize   : cfg ? (cfg.cycleSize || 100) : 100,
// //           fixedInterval: cfg ? (cfg.fixedInterval || 0) : 0,
// //         };
// //       });

// //       setSpinProducts(mapped);
// //     } catch (err) {
// //       console.error('Error loading products:', err);
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   }, []);

// //   const initialLoad = useCallback(async () => {
// //     await fetchSpinEnabledProducts();
// //     await fetchCycleStatus();
// //   }, [fetchSpinEnabledProducts, fetchCycleStatus]);

// //   useEffect(() => {
// //     initialLoad();
// //   }, [initialLoad]);

// //   const handleLabelChange = (id, val) =>
// //     setSpinProducts(prev => prev.map(p => p.id === id ? { ...p, label: val } : p));

// //   const handleWeightChange = (id, val) =>
// //     setSpinProducts(prev => prev.map(p => p.id === id ? { ...p, winWeight: val } : p));

// //   const handleIntervalChange = (id, val) =>
// //     setSpinProducts(prev => prev.map(p => p.id === id ? { ...p, fixedInterval: val } : p));

// //   const saveProbabilities = async () => {
// //     const invalid = spinProducts.find(p => {
// //       const w = Number(p.winWeight);
// //       return isNaN(w) || w < 0 || w > 100;
// //     });
// //     if (invalid) {
// //       alert(`"${invalid.subCategory || invalid.lineItemName}"  Win % should be  (0-100).`);
// //       return;
// //     }

// //     let validationFailed = false;
// //     ['male', 'female'].forEach(g => {
// //       const gp = spinProducts.filter(p => p.gender === g);
// //       const total = gp.reduce((s, p) => s + Number(p.winWeight || 0), 0);
// //       if (total !== 100 && total !== 0) {
// //         alert(`Error: ${g.toUpperCase()} Total Win Percentage  sum should be exact 100% . now total is ${total}% `);
// //         validationFailed = true;
// //       }
// //     });

// //     if (validationFailed) return;

// //     try {
// //       const payload = spinProducts.map(p => ({
// //         id        : undefined,
// //         categoryId: p.id,
// //         winWeight : Number(p.winWeight),
// //         label     : p.label,
// //         percentage: Number(p.winWeight),
// //         gender    : p.gender,
// //         cycleSize : Number(p.gender === 'male' ? maleCycleSize : femaleCycleSize),
// //         fixedInterval: Number(p.fixedInterval) || 0
// //       }));

// //       await api.post('/api/admin/discountconfigs', payload);
// //       setStatus({ msg: '✅ Configurations & Targets saved successfully!', type: 'success' });

// //       setTimeout(() => {
// //         setStatus({ msg: '', type: '' });
// //         initialLoad();
// //       }, 1500);
// //     } catch (err) {
// //       setStatus({ msg: 'Database error while saving.', type: 'error' });
// //     }
// //   };

// //   const handleResetCycle = async (gender) => {
// //     const label = gender === 'male' ? 'Male' : 'Female';
// //     if (!window.confirm(` ${label} configuration; Do you really want to reset the cycle progress?`)) return;

// //     try {
// //       await api.post(`/api/admin/reset-cycle?gender=${gender}`);
// //       setStatus({ msg: `✅ ${label} cycle reset successful.`, type: 'success' });
// //       fetchCycleStatus();
// //       setTimeout(() => setStatus({ msg: '', type: '' }), 1500);
// //     } catch {
// //       setStatus({ msg: 'Failed to reset cycle progress.', type: 'error' });
// //     }
// //   };

// //   const handleFileUpload = async (e) => {
// //     e.preventDefault();
// //     if (!file) return alert('Please select a file first.');
    
// //     const fd = new FormData();
// //     fd.append('file', file);
    
// //     try {
// //       const r = await api.post('/api/admin/import-codes', fd, {
// //         headers: {
// //           'Content-Type': 'multipart/form-data'
// //         }
// //       });
      
// //       if (r.data.success) {
// //         alert(r.data.message);
// //         setFile(null); 
// //       }
// //     } catch (err) {
// //       console.error('Import error details:', err);
// //       const backendError = err.response?.data?.error || 'Import process failed. Server check the status.';
// //       alert(`❌ Error: ${backendError}`);
// //     }
// //   };

// //   const getCycleInfo = (productId) =>
// //     cycleStatus.find(c => c.categoryId === productId);

// //   const ProgressBar = ({ used, quota }) => {
// //     if (quota <= 0) return <span className="text-xs text-slate-400 font-bold">0% Pool (Disabled)</span>;
// //     const pct = Math.min(100, Math.round((used / quota) * 100));
// //     const barColor = pct >= 100 ? '#22C55E' : pct >= 75 ? '#F59E0B' : '#3B82F6';

// //     return (
// //       <div style={{ minWidth: 160 }}>
// //         <div style={{ background: '#E5E7EB', borderRadius: 6, height: 8, overflow: 'hidden', marginBottom: 3 }}>
// //           <div style={{ width: `${pct}%`, background: barColor, height: '100%', transition: 'width 0.4s ease' }} />
// //         </div>
// //         <div style={{ fontSize: 11, color: '#64748B', fontWeight: 600 }}>
// //           {used} / {quota} wins <span style={{ color: barColor }}>( {pct}% used )</span>
// //         </div>
// //       </div>
// //     );
// //   };

// //   const renderTable = (genderType, title, icon, isComplete) => {
// //     const rows = spinProducts.filter(p => p.gender === genderType);
// //     const totalPct = rows.reduce((s, p) => s + Number(p.winWeight || 0), 0);
// //     const isSumOk = totalPct === 100;
// //     const currentTargetValue = genderType === 'male' ? maleCycleSize : femaleCycleSize;

// //     const distributedQuotas = (() => {
// //       const target = Number(currentTargetValue) || 0;
// //       if (target <= 0) return {};

// //       const allocations = rows.map(p => {
// //         const w = Number(p.winWeight || 0);
// //         if (w <= 0) return { id: p.id, quota: 0, remainder: 0, winWeight: 0 };
// //         const exact = (w / 100) * target;
// //         const initial = Math.floor(exact);
// //         return {
// //           id: p.id,
// //           quota: initial,
// //           remainder: exact - initial,
// //           winWeight: w
// //         };
// //       });

// //       const allocatedSum = allocations.reduce((sum, a) => sum + a.quota, 0);
// //       let diff = target - allocatedSum;

// //       if (diff > 0) {
// //         const remainderPool = allocations.filter(a => a.winWeight > 0);
// //         remainderPool.sort((a, b) => b.remainder - a.remainder);
// //         for (let i = 0; i < diff && i < remainderPool.length; i++) {
// //           const item = allocations.find(a => a.id === remainderPool[i].id);
// //           if (item) item.quota += 1;
// //         }
// //       }

// //       allocations.forEach(a => {
// //         if (a.winWeight <= 0) a.quota = 0;
// //       });

// //       const map = {};
// //       allocations.forEach(a => { map[a.id] = a.quota; });
// //       return map;
// //     })();

// //     return (
// //       <div className="bg-white p-6 rounded-xl shadow-sm border mb-8">
// //         <div className="flex flex-wrap justify-between items-center mb-4 gap-4 bg-slate-50 p-4 rounded-xl border">
// //           <div className="flex items-center gap-2">
// //             {icon}
// //             <h2 className="text-xl font-bold text-slate-800">{title}</h2>
// //           </div>
          
// //           <div className="flex items-center gap-3 flex-wrap">
// //             <div className="flex items-center gap-2 bg-white px-3 py-1.5 rounded-lg border shadow-sm">
// //               <span className="text-xs font-bold text-slate-500">CYCLE TARGET:</span>
// //               <input
// //                 type="number"
// //                 min="10"
// //                 className="w-20 text-center font-extrabold text-blue-600 focus:outline-none bg-slate-100 rounded border p-0.5 text-sm"
// //                 value={currentTargetValue}
// //                 onChange={(e) => genderType === 'male' ? setMaleCycleSize(Number(e.target.value)) : setFemaleCycleSize(Number(e.target.value))}
// //               />
// //               <span className="text-xs font-bold text-slate-400">Spins</span>
// //             </div>

// //             <span className={`text-sm font-bold px-3 py-1.5 rounded-lg border ${isSumOk ? 'bg-green-50 text-green-700 border-green-200' : 'bg-orange-50 text-orange-700 border-orange-200'}`}>
// //               Sum: {totalPct}% {isSumOk ? '✓' : '(Must be 100%)'}
// //             </span>
            
// //             <button
// //               onClick={() => handleResetCycle(genderType)}
// //               className="text-xs bg-amber-50 border border-amber-300 text-amber-700 px-3 py-1.5 rounded-lg flex items-center gap-1 hover:bg-amber-100 transition font-semibold"
// //             >
// //               <RotateCcw size={13} /> Reset
// //             </button>
// //           </div>
// //         </div>

// //         {isComplete && (
// //           <div className="mb-4 p-3 rounded-lg bg-emerald-50 border border-emerald-300 flex items-center gap-2 text-emerald-700 text-sm font-bold animate-pulse">
// //             <CheckCircle2 size={16} />
// //             The complete wins have reached zero! The system will automatically reset the pool on the next spin.

// //           </div>
// //         )}

// //         <div className="overflow-x-auto">
// //           <table className="w-full text-left border rounded-lg overflow-hidden">
// //             <thead className="bg-slate-100 border-b text-sm font-bold text-slate-600">
// //               <tr>
// //                 <th className="p-3">Line Item</th>
// //                 <th className="p-3">Category</th>
// //                 <th className="p-3">Sub-Category</th>
// //                 <th className="p-3">Label (Wheel Text)</th>
// //                 <th className="p-3 text-center">Status</th>
// //                 <th className="p-3 text-center w-28">Win Weight (%)</th>
// //                 <th className="p-3 text-center">Dynamic Live Progress</th>
// //                 {/* NEW COLUMN */}
// //                 <th className="p-3 text-center w-32 border-l border-slate-200 bg-blue-50/50">Fixed Interval (Spins)</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {isLoading ? (
// //                 <tr><td colSpan="8" className="p-8 text-center text-gray-400">Loading configurations...</td></tr>
// //               ) : rows.length > 0 ? rows.map((p, idx) => {
// //                 const info = getCycleInfo(p.id);
// //                 const dynamicQuotaDisplay = distributedQuotas[p.id] !== undefined ? distributedQuotas[p.id] : 0;
                
// //                 return (
// //                   <tr key={p.id} className={`border-b ${idx % 2 === 1 ? 'bg-slate-50' : 'bg-white'} hover:bg-blue-50/40 transition`}>
// //                     <td className="p-3 text-gray-700 text-sm">{p.lineItemName}</td>
// //                     <td className="p-3 text-gray-500 text-sm">{p.category}</td>
// //                     <td className="p-3 text-blue-600 font-semibold text-sm">{p.subCategory}</td>
// //                     <td className="p-3">
// //                       <input
// //                         type="text"
// //                         className="border p-2 rounded w-full text-sm outline-none focus:ring-2 focus:ring-blue-400"
// //                         value={p.label}
// //                         onChange={e => handleLabelChange(p.id, e.target.value)}
// //                         placeholder="e.g. 10% OFF"
// //                       />
// //                     </td>
// //                     <td className="p-3 text-center">
// //                       <span className={`px-2 py-1 rounded text-[10px] font-bold ${p.isActive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
// //                         {p.isActive ? 'ACTIVE' : 'INACTIVE'}
// //                       </span>
// //                     </td>
// //                     <td className="p-3">
// //                       <div className="flex items-center justify-center gap-1">
// //                         <input
// //                           type="number"
// //                           className="border p-2 rounded w-16 font-bold text-center outline-none focus:ring-2 focus:ring-blue-400 text-sm"
// //                           value={p.winWeight}
// //                           onChange={e => handleWeightChange(p.id, e.target.value)}
// //                         />
// //                         <span className="text-gray-500 font-bold text-sm">%</span>
// //                       </div>
// //                     </td>
// //                     <td className="p-3 text-center flex justify-center">
// //                       {info ? (
// //                         <ProgressBar used={info.currentCount} quota={info.quota} />
// //                       ) : (
// //                         <span className="text-xs text-indigo-500 font-bold">Target: {dynamicQuotaDisplay} Wins</span>
// //                       )}
// //                     </td>
// //                     {/* NEW INPUT FIELD FOR FIXED INTERVAL */}
// //                     <td className="p-3 border-l border-slate-200">
// //                       <div className="flex flex-col items-center justify-center gap-1">
// //                         <input
// //                           type="number"
// //                           className="border p-2 rounded w-16 font-bold text-center text-blue-700 bg-blue-50 outline-none focus:ring-2 focus:ring-blue-400 text-sm"
// //                           value={p.fixedInterval || 0}
// //                           onChange={e => handleIntervalChange(p.id, e.target.value)}
// //                           title="Set interval. For 120 wins out of 1000, set to 8."
// //                         />
// //                         <span className="text-[10px] text-gray-400 font-bold whitespace-nowrap"> </span>
// //                       </div>
// //                     </td>
// //                   </tr>
// //                 );
// //               }) : (
// //                 <tr><td colSpan="8" className="p-8 text-center text-gray-400">No records found.</td></tr>
// //               )}
// //             </tbody>
// //           </table>
// //         </div>
// //       </div>
// //     );
// //   };

// //   return (
// //     <div className="p-6 bg-gray-50 min-h-screen">
// //       <div className="flex justify-between items-center mb-6">
// //         <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
// //           <Save className="text-blue-600" size={24} /> Professional Dynamic Weight Panel
// //         </h1>
// //         <button onClick={initialLoad} className="bg-white border px-4 py-2 rounded-lg shadow-sm flex items-center gap-2 hover:bg-gray-50 text-sm">
// //           <RefreshCw size={16} className={isLoading ? 'animate-spin' : ''} /> Sync Updates
// //         </button>
// //       </div>

// //       <div className="mb-6 p-4 rounded-lg bg-blue-50 border border-blue-200 flex gap-3 items-start">
// //         <Info size={18} className="text-blue-600 flex-shrink-0 mt-0.5" />
// //         <div className="text-sm text-blue-800">
// //           <p className="font-bold mb-0.5">cyclic process system:</p>
// //           <ul className="list-disc pl-4 space-y-1 text-xs">
// //           </ul>
// //         </div>
// //       </div>

// //       {status.msg && (
// //         <div className={`mb-5 p-4 rounded-lg flex items-center gap-2 text-sm font-semibold ${status.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
// //           {status.type === 'success' ? <CheckCircle2 size={18} /> : <AlertCircle size={18} />}
// //           {status.msg}
// //         </div>
// //       )}

// //       {renderTable('male',   'Mens Pool Configuration',   <UserCircle size={20} className="text-blue-500" />, maleCycleComplete)}
// //       {renderTable('female', 'Womens Pool Configuration', <Users      size={20} className="text-pink-500" />, femaleCycleComplete)}

// //       <div className="sticky bottom-6 z-10">
// //         <button
// //           onClick={saveProbabilities}
// //           className="w-full bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white py-4 rounded-xl font-bold shadow-2xl transition-all text-base tracking-wide uppercase"
// //         >
// //           💾 Save Configurations 
// //         </button>
// //       </div>

// //       {/* ── BULK IMPORT MODULE ── */}
// //       <form onSubmit={handleFileUpload} className="mt-12 bg-white p-6 rounded-xl shadow-sm border max-w-2xl">
// //         <h2 className="text-lg font-semibold mb-4 flex items-center gap-2 text-green-600">
// //           <Upload size={18} /> Bulk Import Discount Codes
// //         </h2>
// //         <input
// //           type="file"
// //           accept=".xlsx,.xls"
// //           onChange={e => setFile(e.target.files[0])}
// //           className="mb-4 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:bg-green-50 file:text-green-700 file:font-semibold cursor-pointer"
// //         />
// //         <button type="submit" className="w-full bg-green-600 text-white py-3 rounded-lg font-bold hover:bg-green-700 transition">
// //           Upload Excel file
// //         </button>
// //       </form>
// //     </div>
// //   );
// // };

// // export default AdminDashboard;







// import React, { useState, useEffect, useCallback } from 'react';
// import api from '../api/api';
// import {
//   Upload, Save, AlertCircle, CheckCircle2, RefreshCw,
//   Users, UserCircle, RotateCcw, Info
// } from 'lucide-react';

// // Canonical saved field in this backend is pkrorpercentage, for example
// // "50%" or "500 PKR". Always trust its suffix before any model default.
// // Return null when a record does not contain enough information to infer a type.
// const getExplicitAmountType = (config) => {
//   const storedReward = String(config?.pkrorpercentage ?? '').trim();
//   if (storedReward.includes('%')) return 'percentage';
//   if (/\bpkr\b/i.test(storedReward)) return 'amount';

//   const configuredType = String(config?.amountType ?? config?.valueType ?? '').trim().toLowerCase();
//   if (['percentage', 'percent', '%'].includes(configuredType)) return 'percentage';
//   if (['amount', 'pkr', 'fixed'].includes(configuredType)) return 'amount';

//   const oldAmount = String(config?.amount ?? '').trim();
//   if (oldAmount.includes('%')) return 'percentage';
//   if (/\bpkr\b/i.test(oldAmount)) return 'amount';
//   return null;
// };

// const getAmountType = (config) => getExplicitAmountType(config) || 'amount';

// // The dropdown is per gender pool, not per row. Some old rows may have an
// // empty pkrorpercentage value, so do not infer the whole pool from the first
// // configured row only. Use all rows with an explicit saved type and choose the
// // majority; this keeps the selector correct after reload when at least one
// // row in that pool contains a saved reward value.
// const inferPoolAmountType = (products, gender) => {
//   const votes = products
//     .filter(product => (product.gender || 'male').toLowerCase() === gender)
//     .flatMap(product => Array.isArray(product.discounts) ? product.discounts : [])
//     .map(getExplicitAmountType)
//     .filter(Boolean);

//   if (!votes.length) return 'amount';

//   const percentageVotes = votes.filter(type => type === 'percentage').length;
//   const amountVotes = votes.filter(type => type === 'amount').length;
//   if (percentageVotes > amountVotes) return 'percentage';
//   if (amountVotes > percentageVotes) return 'amount';

//   // Tie-break consistently using the first explicit saved value returned by API.
//   return votes[0];
// };

// // Extract the numeric value from either a numeric amount field or the legacy
// // formatted pkrorpercentage value, without carrying PKR/% into the input.
// const getAmountValue = (value) => {
//   if (value === null || value === undefined || value === '') return '';
//   const match = String(value).replace(/,/g, '').match(/\d+(?:\.\d+)?/);
//   return match ? match[0] : '';
// };

// const AdminDashboard = () => {
//   const [spinProducts, setSpinProducts] = useState([]);
//   // Each pool has its own reward type selector in that pool's table heading.
//   const [maleAmountType, setMaleAmountType] = useState('amount');
//   const [femaleAmountType, setFemaleAmountType] = useState('amount');
//   const [file, setFile] = useState(null);
//   const [status, setStatus] = useState({ msg: '', type: '' });
//   const [isLoading, setIsLoading] = useState(true);
//   const [cycleStatus, setCycleStatus] = useState([]);
//   const [maleCycleComplete, setMaleCycleComplete] = useState(false);
//   const [femaleCycleComplete, setFemaleCycleComplete] = useState(false);

//   // Dynamic Cycle Targets
//   const [maleCycleSize, setMaleCycleSize] = useState(100);
//   const [femaleCycleSize, setFemaleCycleSize] = useState(100);

//   const fetchCycleStatus = useCallback(async () => {
//     try {
//       const res = await api.get('/api/admin/cycle-status');
//       if (res.data.success) {
//         setCycleStatus(res.data.data);
//         setMaleCycleComplete(res.data.maleCycleComplete);
//         setFemaleCycleComplete(res.data.femaleCycleComplete);

//         const maleCfg = res.data.data.find(d => d.gender === 'male');
//         if (maleCfg && maleCfg.cycleSize) setMaleCycleSize(maleCfg.cycleSize);

//         const femaleCfg = res.data.data.find(d => d.gender === 'female');
//         if (femaleCfg && femaleCfg.cycleSize) setFemaleCycleSize(femaleCfg.cycleSize);
//       }
//     } catch (err) {
//       console.error('Cycle status error:', err);
//     }
//   }, []);

//   const fetchSpinEnabledProducts = useCallback(async () => {
//     try {
//       setIsLoading(true);
//       const res = await api.get('/api/products');
//       const active = res.data.filter(p => p.addInSpin === true);

//       const mapped = active.map(p => {
//         const cfg = p.discounts?.length ? p.discounts[0] : null;
//         return {
//           id: p.id,
//           lineItemName: p.lineItemName || '',
//           category: p.category || '',
//           subCategory: p.subCategory || '',
//           amount: getAmountValue(cfg?.pkrorpercentage || cfg?.amount),
//           amountType: getAmountType(cfg),
//           label: cfg ? (cfg.label || '') : '',
//           winWeight: cfg ? cfg.winWeight : '0',
//           isActive: p.isActive,
//           gender: (p.gender || 'male').toLowerCase(),
//           cycleSize: cfg ? (cfg.cycleSize || 100) : 100,
//           fixedInterval: cfg ? (cfg.fixedInterval || 0) : 0,
//         };
//       });

//       // Restore each table-header selector independently from saved values.
//       // Infer from pkrorpercentage across the pool instead of blindly taking the
//       // first row, which may be blank or an old record with no reward value.
//       setMaleAmountType(inferPoolAmountType(active, 'male'));
//       setFemaleAmountType(inferPoolAmountType(active, 'female'));

//       setSpinProducts(mapped);
//       return true;
//     } catch (err) {
//       console.error('Error loading products:', err);
//       return false;
//     } finally {
//       setIsLoading(false);
//     }
//   }, []);

//   const initialLoad = useCallback(async () => {
//     await fetchSpinEnabledProducts();
//     await fetchCycleStatus();
//   }, [fetchSpinEnabledProducts, fetchCycleStatus]);

//   useEffect(() => {
//     initialLoad();
//   }, [initialLoad]);

//   const handleLabelChange = (id, val) =>
//     setSpinProducts(prev => prev.map(p => p.id === id ? { ...p, label: val } : p));

//   const handleAmountChange = (id, val) =>
//     setSpinProducts(prev => prev.map(p => p.id === id ? { ...p, amount: val } : p));

//   // Each header selector applies only to rows in its own gender pool.
//   const handleAmountTypeChange = (gender, val) => {
//     if (gender === 'male') {
//       setMaleAmountType(val);
//     } else {
//       setFemaleAmountType(val);
//     }
//   };

//   const handleWeightChange = (id, val) =>
//     setSpinProducts(prev => prev.map(p => p.id === id ? { ...p, winWeight: val } : p));

//   const handleIntervalChange = (id, val) =>
//     setSpinProducts(prev => prev.map(p => p.id === id ? { ...p, fixedInterval: val } : p));

//   const saveProbabilities = async () => {
//     const invalid = spinProducts.find(p => {
//       const w = Number(p.winWeight);
//       return isNaN(w) || w < 0 || w > 100;
//     });

//     if (invalid) {
//       alert(`"${invalid.subCategory || invalid.lineItemName}" Win % should be between 0 and 100.`);
//       return;
//     }

//     let validationFailed = false;
//     ['male', 'female'].forEach(g => {
//       const gp = spinProducts.filter(p => p.gender === g);
//       const total = gp.reduce((s, p) => s + Number(p.winWeight || 0), 0);
//       if (total !== 100 && total !== 0) {
//         alert(`Error: ${g.toUpperCase()} total Win Weight must equal exactly 100%. Current total is ${total}%.`);
//         validationFailed = true;
//       }
//     });

//     if (validationFailed) return;

//     try {
//       const payload = spinProducts.map(p => ({
//         id: undefined,
//         categoryId: p.id,
//         winWeight: Number(p.winWeight),
//         label: p.label,
//         // Use the reward type selected in this product's own gender table.
//         amount: p.amount === '' || p.amount == null ? '' : String(p.amount),
//         amountType: (p.gender === 'male' ? maleAmountType : femaleAmountType) || 'amount',
//         percentage: Number(p.winWeight),
//         gender: p.gender,
//         cycleSize: Number(p.gender === 'male' ? maleCycleSize : femaleCycleSize),
//         fixedInterval: Number(p.fixedInterval) || 0
//       }));

//       await api.post('/api/admin/discountconfigs', payload);

//       // Re-fetch the saved values from GET /api/products before reporting completion.
//       // This backend persists the selected type/value in discounts[].pkrorpercentage; the loader reads that field.
//       const productsReloaded = await fetchSpinEnabledProducts();
//       await fetchCycleStatus();

//       if (!productsReloaded) {
//         setStatus({
//           msg: 'Configurations were submitted, but the frontend could not reload them. Check GET /api/products and the backend model fields.',
//           type: 'error'
//         });
//         return;
//       }

//       setStatus({ msg: '✅ Configurations saved and refreshed from the database!', type: 'success' });
//       setTimeout(() => setStatus({ msg: '', type: '' }), 3000);
//     } catch (err) {
//       console.error('Save configurations error:', err.response?.data || err);
//       const serverMessage = err.response?.data?.error || err.response?.data?.message;
//       setStatus({
//         msg: serverMessage
//           ? `Database error while saving: ${serverMessage}`
//           : 'Database error while saving. Check the backend route, DiscountConfig model, and database columns for amount and amountType.',
//         type: 'error'
//       });
//     }
//   };

//   const handleResetCycle = async (gender) => {
//     const label = gender === 'male' ? 'Male' : 'Female';
//     if (!window.confirm(`${label} configuration: do you really want to reset the cycle progress?`)) return;

//     try {
//       await api.post(`/api/admin/reset-cycle?gender=${gender}`);
//       setStatus({ msg: `✅ ${label} cycle reset successful.`, type: 'success' });
//       fetchCycleStatus();
//       setTimeout(() => setStatus({ msg: '', type: '' }), 1500);
//     } catch {
//       setStatus({ msg: 'Failed to reset cycle progress.', type: 'error' });
//     }
//   };

//   const handleFileUpload = async (e) => {
//     e.preventDefault();
//     if (!file) return alert('Please select a file first.');

//     const fd = new FormData();
//     fd.append('file', file);

//     try {
//       const r = await api.post('/api/admin/import-codes', fd, {
//         headers: { 'Content-Type': 'multipart/form-data' }
//       });

//       if (r.data.success) {
//         alert(r.data.message);
//         setFile(null);
//         e.target.reset();
//       }
//     } catch (err) {
//       console.error('Import error details:', err);
//       const backendError = err.response?.data?.error || 'Import process failed. Check the server status.';
//       alert(`❌ Error: ${backendError}`);
//     }
//   };

//   const getCycleInfo = (productId) =>
//     cycleStatus.find(c => c.categoryId === productId);

//   const ProgressBar = ({ used, quota }) => {
//     if (quota <= 0) return <span className="text-xs text-slate-400 font-bold">0% Pool (Disabled)</span>;
//     const pct = Math.min(100, Math.round((used / quota) * 100));
//     const barColor = pct >= 100 ? '#22C55E' : pct >= 75 ? '#F59E0B' : '#3B82F6';

//     return (
//       <div style={{ minWidth: 160 }}>
//         <div style={{ background: '#E5E7EB', borderRadius: 6, height: 8, overflow: 'hidden', marginBottom: 3 }}>
//           <div style={{ width: `${pct}%`, background: barColor, height: '100%', transition: 'width 0.4s ease' }} />
//         </div>
//         <div style={{ fontSize: 11, color: '#64748B', fontWeight: 600 }}>
//           {used} / {quota} wins <span style={{ color: barColor }}>( {pct}% used )</span>
//         </div>
//       </div>
//     );
//   };

//   const renderTable = (genderType, title, icon, isComplete) => {
//     const rows = spinProducts.filter(p => p.gender === genderType);
//     const totalPct = rows.reduce((s, p) => s + Number(p.winWeight || 0), 0);
//     const isSumOk = totalPct === 100;
//     const currentTargetValue = genderType === 'male' ? maleCycleSize : femaleCycleSize;
//     const currentAmountType = genderType === 'male' ? maleAmountType : femaleAmountType;

//     const distributedQuotas = (() => {
//       const target = Number(currentTargetValue) || 0;
//       if (target <= 0) return {};

//       const allocations = rows.map(p => {
//         const w = Number(p.winWeight || 0);
//         if (w <= 0) return { id: p.id, quota: 0, remainder: 0, winWeight: 0 };
//         const exact = (w / 100) * target;
//         const initial = Math.floor(exact);
//         return { id: p.id, quota: initial, remainder: exact - initial, winWeight: w };
//       });

//       const allocatedSum = allocations.reduce((sum, a) => sum + a.quota, 0);
//       const diff = target - allocatedSum;

//       if (diff > 0) {
//         const remainderPool = allocations.filter(a => a.winWeight > 0);
//         remainderPool.sort((a, b) => b.remainder - a.remainder);
//         for (let i = 0; i < diff && i < remainderPool.length; i++) {
//           const item = allocations.find(a => a.id === remainderPool[i].id);
//           if (item) item.quota += 1;
//         }
//       }

//       allocations.forEach(a => {
//         if (a.winWeight <= 0) a.quota = 0;
//       });

//       const map = {};
//       allocations.forEach(a => { map[a.id] = a.quota; });
//       return map;
//     })();

//     return (
//       <div className="bg-white p-6 rounded-xl shadow-sm border mb-8">
//         <div className="flex flex-wrap justify-between items-center mb-4 gap-4 bg-slate-50 p-4 rounded-xl border">
//           <div className="flex items-center gap-2">
//             {icon}
//             <h2 className="text-xl font-bold text-slate-800">{title}</h2>
//           </div>

//           <div className="flex items-center gap-3 flex-wrap">
//             <div className="flex items-center gap-2 bg-white px-3 py-1.5 rounded-lg border shadow-sm">
//               <span className="text-xs font-bold text-slate-500">CYCLE TARGET:</span>
//               <input
//                 type="number"
//                 min="10"
//                 className="w-20 text-center font-extrabold text-blue-600 focus:outline-none bg-slate-100 rounded border p-0.5 text-sm"
//                 value={currentTargetValue}
//                 onChange={(e) => genderType === 'male' ? setMaleCycleSize(Number(e.target.value)) : setFemaleCycleSize(Number(e.target.value))}
//               />
//               <span className="text-xs font-bold text-slate-400">Spins</span>
//             </div>

//             <span className={`text-sm font-bold px-3 py-1.5 rounded-lg border ${isSumOk ? 'bg-green-50 text-green-700 border-green-200' : 'bg-orange-50 text-orange-700 border-orange-200'}`}>
//               Sum: {totalPct}% {isSumOk ? '✓' : '(Must be 100%)'}
//             </span>

//             <button
//               onClick={() => handleResetCycle(genderType)}
//               className="text-xs bg-amber-50 border border-amber-300 text-amber-700 px-3 py-1.5 rounded-lg flex items-center gap-1 hover:bg-amber-100 transition font-semibold"
//             >
//               <RotateCcw size={13} /> Reset
//             </button>
//           </div>
//         </div>

//         {isComplete && (
//           <div className="mb-4 p-3 rounded-lg bg-emerald-50 border border-emerald-300 flex items-center gap-2 text-emerald-700 text-sm font-bold animate-pulse">
//             <CheckCircle2 size={16} />
//             The complete wins have reached zero! The system will automatically reset the pool on the next spin.
//           </div>
//         )}

//         <div className="overflow-x-auto">
//           <table
//             className="w-full min-w-[1560px] table-fixed text-left border rounded-lg overflow-hidden"
//             style={{ tableLayout: 'fixed' }}
//           >
//             <colgroup>
//               <col style={{ width: '190px' }} />
//               <col style={{ width: '130px' }} />
//               <col style={{ width: '150px' }} />
//               <col style={{ width: '190px' }} />
//               <col style={{ width: '300px' }} />
//               <col style={{ width: '95px' }} />
//               <col style={{ width: '125px' }} />
//               <col style={{ width: '230px' }} />
//               <col style={{ width: '150px' }} />
//             </colgroup>
//             <thead className="bg-slate-100 border-b text-sm font-bold text-slate-600">
//               <tr>
//                 <th className="p-3 align-middle leading-tight">Line Item</th>
//                 <th className="p-3 align-middle leading-tight">Category</th>
//                 <th className="p-3 align-middle leading-tight">Sub-Category</th>
//                 {/* Each pool has its own header selector, matching the Mens and Womens layouts. */}
//                 <th className="p-3 align-middle leading-tight bg-violet-50/70">
//                   <div className="flex flex-col gap-1.5">
//                     <span>Amount / %</span>
//                     <select
//                       className="block w-full min-w-0 box-border border border-violet-200 px-2 py-1.5 rounded-lg text-xs font-semibold text-slate-700 bg-white outline-none focus:ring-2 focus:ring-violet-400"
//                       value={currentAmountType}
//                       onChange={e => handleAmountTypeChange(genderType, e.target.value)}
//                       aria-label={`Reward type for ${genderType} line items`}
//                       title={`This selection applies only to line items in the ${genderType} table`}
//                     >
//                       <option value="amount">Amount (PKR)</option>
//                       <option value="percentage">Percentage (%)</option>
//                     </select>
//                   </div>
//                 </th>
//                 <th className="p-3 align-middle leading-tight">Label (Wheel Text)</th>
//                 <th className="p-3 text-center align-middle leading-tight">Status</th>
//                 <th className="p-3 text-center align-middle leading-tight">Win Weight (%)</th>
//                 <th className="p-3 text-center align-middle leading-tight">Dynamic Live Progress</th>
//                 <th className="p-3 text-center align-middle leading-tight border-l border-slate-200 bg-blue-50/50">Fixed Interval (Spins)</th>
//               </tr>
//             </thead>
//             <tbody>
//               {isLoading ? (
//                 <tr><td colSpan="9" className="p-8 text-center text-gray-400">Loading configurations...</td></tr>
//               ) : rows.length > 0 ? rows.map((p, idx) => {
//                 const info = getCycleInfo(p.id);
//                 const dynamicQuotaDisplay = distributedQuotas[p.id] !== undefined ? distributedQuotas[p.id] : 0;

//                 return (
//                   <tr key={p.id} className={`border-b ${idx % 2 === 1 ? 'bg-slate-50' : 'bg-white'} hover:bg-blue-50/40 transition`}>
//                     <td className="p-3 align-middle text-gray-700 text-sm break-words">{p.lineItemName}</td>
//                     <td className="p-3 align-middle text-gray-500 text-sm break-words">{p.category}</td>
//                     <td className="p-3 align-middle text-blue-600 font-semibold text-sm break-words">{p.subCategory}</td>
//                     <td className="p-3 align-middle bg-violet-50/30">
//                       <div className="flex w-full min-w-0 items-center overflow-hidden rounded-lg border border-violet-200 bg-white focus-within:ring-2 focus-within:ring-violet-400">
//                         {currentAmountType === 'amount' && (
//                           <span className="shrink-0 border-r border-violet-100 bg-violet-50 px-2 py-2 text-xs font-bold text-violet-700">
//                             PKR
//                           </span>
//                         )}
//                         <input
//                           type="number"
//                           min="0"
//                           step="any"
//                           className="block w-full min-w-0 box-border border-0 px-2 py-2 text-sm font-semibold text-slate-700 outline-none focus:ring-0"
//                           value={p.amount}
//                           onChange={e => handleAmountChange(p.id, e.target.value)}
//                           aria-label={`Reward value for ${p.lineItemName || p.subCategory}`}
//                           placeholder="500"
//                           title={currentAmountType === 'percentage' ? 'Enter percentage value; % is shown automatically.' : 'Enter amount; PKR is shown automatically.'}
//                         />
//                         {currentAmountType === 'percentage' && (
//                           <span className="shrink-0 border-l border-violet-100 bg-violet-50 px-2.5 py-2 text-sm font-bold text-violet-700">
//                             %
//                           </span>
//                         )}
//                       </div>
//                     </td>
//                     <td className="p-3 align-middle">
//                       <input
//                         type="text"
//                         className="block w-full min-w-0 box-border border border-slate-300 px-3 py-2.5 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
//                         value={p.label}
//                         onChange={e => handleLabelChange(p.id, e.target.value)}
//                         placeholder="e.g. Fragrance / 10% OFF"
//                         aria-label={`Wheel label for ${p.lineItemName || p.subCategory}`}
//                       />
//                     </td>
//                     <td className="p-3 text-center align-middle">
//                       <span className={`px-2 py-1 rounded text-[10px] font-bold ${p.isActive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
//                         {p.isActive ? 'ACTIVE' : 'INACTIVE'}
//                       </span>
//                     </td>
//                     <td className="p-3 align-middle">
//                       <div className="flex items-center justify-center gap-1">
//                         <input
//                           type="number"
//                           min="0"
//                           max="100"
//                           className="border p-2 rounded w-16 font-bold text-center outline-none focus:ring-2 focus:ring-blue-400 text-sm"
//                           value={p.winWeight}
//                           onChange={e => handleWeightChange(p.id, e.target.value)}
//                         />
//                         <span className="text-gray-500 font-bold text-sm">%</span>
//                       </div>
//                     </td>
//                     <td className="p-3 text-center align-middle">
//                       <div className="flex justify-center">
//                         {info ? (
//                           <ProgressBar used={info.currentCount} quota={info.quota} />
//                         ) : (
//                           <span className="text-xs text-indigo-500 font-bold">Target: {dynamicQuotaDisplay} Wins</span>
//                         )}
//                       </div>
//                     </td>
//                     <td className="p-3 text-center align-middle border-l border-slate-200">
//                       <div className="flex flex-col items-center justify-center gap-1">
//                         <input
//                           type="number"
//                           min="0"
//                           className="border p-2 rounded w-16 font-bold text-center text-blue-700 bg-blue-50 outline-none focus:ring-2 focus:ring-blue-400 text-sm"
//                           value={p.fixedInterval || 0}
//                           onChange={e => handleIntervalChange(p.id, e.target.value)}
//                           title="Set the fixed interval in spins"
//                         />
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               }) : (
//                 <tr><td colSpan="9" className="p-8 text-center text-gray-400">No records found.</td></tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="p-6 bg-gray-50 min-h-screen">
//       <div className="flex justify-between items-center mb-6">
//         <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
//           <Save className="text-blue-600" size={24} /> Professional Dynamic Weight Panel
//         </h1>
//         <button onClick={initialLoad} className="bg-white border px-4 py-2 rounded-lg shadow-sm flex items-center gap-2 hover:bg-gray-50 text-sm">
//           <RefreshCw size={16} className={isLoading ? 'animate-spin' : ''} /> Sync Updates
//         </button>
//       </div>

//       <div className="mb-6 p-4 rounded-lg bg-blue-50 border border-blue-200 flex gap-3 items-start">
//         <Info size={18} className="text-blue-600 flex-shrink-0 mt-0.5" />
//         <div className="text-sm text-blue-800">
//           <p className="font-bold mb-0.5">Cyclic process system:</p>
//           <ul className="list-disc pl-4 space-y-1 text-xs">
//             <li><strong>Amount / %:</strong> use the dropdown in each table heading. The Mens selector applies only to Mens rows, and the Womens selector applies only to Womens rows. Amount shows a PKR prefix, while Percentage shows a % suffix.</li>
//             <li><strong>Label (Wheel Text)</strong> is the text shown on the wheel, such as Fragrance. The existing Win Weight (%) still controls the chance of winning that line item.</li>
//           </ul>
//         </div>
//       </div>

//       {status.msg && (
//         <div className={`mb-5 p-4 rounded-lg flex items-center gap-2 text-sm font-semibold ${status.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
//           {status.type === 'success' ? <CheckCircle2 size={18} /> : <AlertCircle size={18} />}
//           {status.msg}
//         </div>
//       )}

//       {renderTable('male', 'Mens Pool Configuration', <UserCircle size={20} className="text-blue-500" />, maleCycleComplete)}
//       {renderTable('female', 'Womens Pool Configuration', <Users size={20} className="text-pink-500" />, femaleCycleComplete)}

//       <div className="sticky bottom-6 z-10">
//         <button
//           onClick={saveProbabilities}
//           className="w-full bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white py-4 rounded-xl font-bold shadow-2xl transition-all text-base tracking-wide uppercase"
//         >
//           💾 Save Configurations
//         </button>
//       </div>

//       {/* Bulk import module */}
//       <form onSubmit={handleFileUpload} className="mt-12 bg-white p-6 rounded-xl shadow-sm border max-w-2xl">
//         <h2 className="text-lg font-semibold mb-4 flex items-center gap-2 text-green-600">
//           <Upload size={18} /> Bulk Import Discount Codes
//         </h2>
//         <input
//           type="file"
//           accept=".xlsx,.xls"
//           onChange={e => setFile(e.target.files[0])}
//           className="mb-4 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:bg-green-50 file:text-green-700 file:font-semibold cursor-pointer"
//         />
//         <button type="submit" className="w-full bg-green-600 text-white py-3 rounded-lg font-bold hover:bg-green-700 transition">
//           Upload Excel file
//         </button>
//       </form>
//     </div>
//   );
// };

// export default AdminDashboard;












import React, { useState, useEffect, useCallback } from 'react';
import api from '../api/api';
import {
  Upload, Save, AlertCircle, CheckCircle2, RefreshCw,
  Users, UserCircle, RotateCcw, Info
} from 'lucide-react';

// Canonical saved field in this backend is pkrorpercentage, for example
// "50%" or "500 PKR". Always trust its suffix before any model default.
// Return null when a record does not contain enough information to infer a type.
const getExplicitAmountType = (config) => {
  const storedReward = String(config?.pkrorpercentage ?? '').trim();
  if (storedReward.includes('%')) return 'percentage';
  if (/\bpkr\b/i.test(storedReward)) return 'amount';

  const configuredType = String(config?.amountType ?? config?.valueType ?? '').trim().toLowerCase();
  if (['percentage', 'percent', '%'].includes(configuredType)) return 'percentage';
  if (['amount', 'pkr', 'fixed'].includes(configuredType)) return 'amount';

  const oldAmount = String(config?.amount ?? '').trim();
  if (oldAmount.includes('%')) return 'percentage';
  if (/\bpkr\b/i.test(oldAmount)) return 'amount';
  return null;
};

const getAmountType = (config) => getExplicitAmountType(config) || 'amount';

// The dropdown is per gender pool, not per row. Some old rows may have an
// empty pkrorpercentage value, so do not infer the whole pool from the first
// configured row only. Use all rows with an explicit saved type and choose the
// majority; this keeps the selector correct after reload when at least one
// row in that pool contains a saved reward value.
const inferPoolAmountType = (products, gender) => {
  const votes = products
    .filter(product => (product.gender || 'male').toLowerCase() === gender)
    .flatMap(product => Array.isArray(product.discounts) ? product.discounts : [])
    .map(getExplicitAmountType)
    .filter(Boolean);

  if (!votes.length) return 'amount';

  const percentageVotes = votes.filter(type => type === 'percentage').length;
  const amountVotes = votes.filter(type => type === 'amount').length;
  if (percentageVotes > amountVotes) return 'percentage';
  if (amountVotes > percentageVotes) return 'amount';

  // Tie-break consistently using the first explicit saved value returned by API.
  return votes[0];
};

// Extract the numeric value from either a numeric amount field or the legacy
// formatted pkrorpercentage value, without carrying PKR/% into the input.
const getAmountValue = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const match = String(value).replace(/,/g, '').match(/\d+(?:\.\d+)?/);
  return match ? match[0] : '';
};

const AdminDashboard = () => {
  const [spinProducts, setSpinProducts] = useState([]);
  // Each pool has its own reward type selector in that pool's table heading.
  const [maleAmountType, setMaleAmountType] = useState('amount');
  const [femaleAmountType, setFemaleAmountType] = useState('amount');
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState({ msg: '', type: '' });
  const [isLoading, setIsLoading] = useState(true);
  const [cycleStatus, setCycleStatus] = useState([]);
  const [maleCycleComplete, setMaleCycleComplete] = useState(false);
  const [femaleCycleComplete, setFemaleCycleComplete] = useState(false);

  // Dynamic Cycle Targets
  const [maleCycleSize, setMaleCycleSize] = useState(100);
  const [femaleCycleSize, setFemaleCycleSize] = useState(100);

  const fetchCycleStatus = useCallback(async () => {
    try {
      const res = await api.get('/api/admin/cycle-status');
      if (res.data.success) {
        setCycleStatus(res.data.data);
        setMaleCycleComplete(res.data.maleCycleComplete);
        setFemaleCycleComplete(res.data.femaleCycleComplete);

        const maleCfg = res.data.data.find(d => d.gender === 'male');
        if (maleCfg && maleCfg.cycleSize) setMaleCycleSize(maleCfg.cycleSize);

        const femaleCfg = res.data.data.find(d => d.gender === 'female');
        if (femaleCfg && femaleCfg.cycleSize) setFemaleCycleSize(femaleCfg.cycleSize);
      }
    } catch (err) {
      console.error('Cycle status error:', err);
    }
  }, []);

  const fetchSpinEnabledProducts = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await api.get('/api/products');
      const active = res.data.filter(p => p.addInSpin === true);

      const mapped = active.map(p => {
        const cfg = p.discounts?.length ? p.discounts[0] : null;
        return {
          id: p.id,
          lineItemName: p.lineItemName || '',
          category: p.category || '',
          subCategory: p.subCategory || '',
          amount: getAmountValue(cfg?.pkrorpercentage || cfg?.amount),
          amountType: getAmountType(cfg),
          label: cfg ? (cfg.label || '') : '',
          winWeight: cfg ? cfg.winWeight : '0',
          isActive: p.isActive,
          gender: (p.gender || 'male').toLowerCase(),
          cycleSize: cfg ? (cfg.cycleSize || 100) : 100,
          fixedInterval: cfg ? (cfg.fixedInterval || 0) : 0,
        };
      });

      // Restore each table-header selector independently from saved values.
      // Infer from pkrorpercentage across the pool instead of blindly taking the
      // first row, which may be blank or an old record with no reward value.
      setMaleAmountType(inferPoolAmountType(active, 'male'));
      setFemaleAmountType(inferPoolAmountType(active, 'female'));

      setSpinProducts(mapped);
      return true;
    } catch (err) {
      console.error('Error loading products:', err);
      return false;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const initialLoad = useCallback(async () => {
    await fetchSpinEnabledProducts();
    await fetchCycleStatus();
  }, [fetchSpinEnabledProducts, fetchCycleStatus]);

  useEffect(() => {
    initialLoad();
  }, [initialLoad]);

  const handleLabelChange = (id, val) =>
    setSpinProducts(prev => prev.map(p => p.id === id ? { ...p, label: val } : p));

  const handleAmountChange = (id, val) =>
    setSpinProducts(prev => prev.map(p => p.id === id ? { ...p, amount: val } : p));

  // Each header selector applies only to rows in its own gender pool.
  const handleAmountTypeChange = (gender, val) => {
    if (gender === 'male') {
      setMaleAmountType(val);
    } else {
      setFemaleAmountType(val);
    }
  };

  const handleWeightChange = (id, val) =>
    setSpinProducts(prev => prev.map(p => p.id === id ? { ...p, winWeight: val } : p));

  const handleIntervalChange = (id, val) =>
    setSpinProducts(prev => prev.map(p => p.id === id ? { ...p, fixedInterval: val } : p));

  const saveProbabilities = async () => {
    const invalid = spinProducts.find(p => {
      const w = Number(p.winWeight);
      return isNaN(w) || w < 0 || w > 100;
    });

    if (invalid) {
      alert(`"${invalid.subCategory || invalid.lineItemName}" Win % should be between 0 and 100.`);
      return;
    }

    let validationFailed = false;
    ['male', 'female'].forEach(g => {
      const gp = spinProducts.filter(p => p.gender === g);
      const total = gp.reduce((s, p) => s + Number(p.winWeight || 0), 0);
      if (total !== 100 && total !== 0) {
        alert(`Error: ${g.toUpperCase()} total Win Weight must equal exactly 100%. Current total is ${total}%.`);
        validationFailed = true;
      }
    });

    if (validationFailed) return;

    try {
      const payload = spinProducts.map(p => {
        const currentType = p.gender === 'male' ? maleAmountType : femaleAmountType;
        const rawAmount = String(p.amount ?? '').trim();
        
        let formattedPkrorPercentage = '';
        if (rawAmount !== '') {
          const cleanNum = rawAmount.replace(/pkr|%/gi, '').trim();
          if (currentType === 'amount') {
            formattedPkrorPercentage = `PKR ${cleanNum}`; // 👈 Yahan PKR pehle aur value baad mein aayegi
          } else {
            formattedPkrorPercentage = `${cleanNum}%`;    // 👈 Yahan percentage value ke baad % aayega
          }
        }

        return {
          id: undefined,
          categoryId: p.id,
          winWeight: Number(p.winWeight),
          label: p.label,
          amount: rawAmount,
          amountType: currentType || 'amount',
          pkrorpercentage: formattedPkrorPercentage,
          percentage: Number(p.winWeight),
          gender: p.gender,
          cycleSize: Number(p.gender === 'male' ? maleCycleSize : femaleCycleSize),
          fixedInterval: Number(p.fixedInterval) || 0
        };
      });

      await api.post('/api/admin/discountconfigs', payload);

      const productsReloaded = await fetchSpinEnabledProducts();
      await fetchCycleStatus();

      if (!productsReloaded) {
        setStatus({
          msg: 'Configurations were submitted, but the frontend could not reload them.',
          type: 'error'
        });
        return;
      }

      setStatus({ msg: '✅ Configurations saved and refreshed from the database!', type: 'success' });
      setTimeout(() => setStatus({ msg: '', type: '' }), 3000);
    } catch (err) {
      console.error('Save configurations error:', err.response?.data || err);
      const serverMessage = err.response?.data?.error || err.response?.data?.message;
      setStatus({
        msg: serverMessage ? `Database error while saving: ${serverMessage}` : 'Database error while saving.',
        type: 'error'
      });
    }
  };

  const handleResetCycle = async (gender) => {
    const label = gender === 'male' ? 'Male' : 'Female';
    if (!window.confirm(`${label} configuration: do you really want to reset the cycle progress?`)) return;

    try {
      await api.post(`/api/admin/reset-cycle?gender=${gender}`);
      setStatus({ msg: `✅ ${label} cycle reset successful.`, type: 'success' });
      fetchCycleStatus();
      setTimeout(() => setStatus({ msg: '', type: '' }), 1500);
    } catch {
      setStatus({ msg: 'Failed to reset cycle progress.', type: 'error' });
    }
  };

  const handleFileUpload = async (e) => {
    e.preventDefault();
    if (!file) return alert('Please select a file first.');

    const fd = new FormData();
    fd.append('file', file);

    try {
      const r = await api.post('/api/admin/import-codes', fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (r.data.success) {
        alert(r.data.message);
        setFile(null);
        e.target.reset();
      }
    } catch (err) {
      console.error('Import error details:', err);
      const backendError = err.response?.data?.error || 'Import process failed. Check the server status.';
      alert(`❌ Error: ${backendError}`);
    }
  };

  const getCycleInfo = (productId) =>
    cycleStatus.find(c => c.categoryId === productId);

  const ProgressBar = ({ used, quota }) => {
    if (quota <= 0) return <span className="text-xs text-slate-400 font-bold">0% Pool (Disabled)</span>;
    const pct = Math.min(100, Math.round((used / quota) * 100));
    const barColor = pct >= 100 ? '#22C55E' : pct >= 75 ? '#F59E0B' : '#3B82F6';

    return (
      <div style={{ minWidth: 160 }}>
        <div style={{ background: '#E5E7EB', borderRadius: 6, height: 8, overflow: 'hidden', marginBottom: 3 }}>
          <div style={{ width: `${pct}%`, background: barColor, height: '100%', transition: 'width 0.4s ease' }} />
        </div>
        <div style={{ fontSize: 11, color: '#64748B', fontWeight: 600 }}>
          {used} / {quota} wins <span style={{ color: barColor }}>( {pct}% used )</span>
        </div>
      </div>
    );
  };

  const renderTable = (genderType, title, icon, isComplete) => {
    const rows = spinProducts.filter(p => p.gender === genderType);
    const totalPct = rows.reduce((s, p) => s + Number(p.winWeight || 0), 0);
    const isSumOk = totalPct === 100;
    const currentTargetValue = genderType === 'male' ? maleCycleSize : femaleCycleSize;
    const currentAmountType = genderType === 'male' ? maleAmountType : femaleAmountType;

    const distributedQuotas = (() => {
      const target = Number(currentTargetValue) || 0;
      if (target <= 0) return {};

      const allocations = rows.map(p => {
        const w = Number(p.winWeight || 0);
        if (w <= 0) return { id: p.id, quota: 0, remainder: 0, winWeight: 0 };
        const exact = (w / 100) * target;
        const initial = Math.floor(exact);
        return { id: p.id, quota: initial, remainder: exact - initial, winWeight: w };
      });

      const allocatedSum = allocations.reduce((sum, a) => sum + a.quota, 0);
      const diff = target - allocatedSum;

      if (diff > 0) {
        const remainderPool = allocations.filter(a => a.winWeight > 0);
        remainderPool.sort((a, b) => b.remainder - a.remainder);
        for (let i = 0; i < diff && i < remainderPool.length; i++) {
          const item = allocations.find(a => a.id === remainderPool[i].id);
          if (item) item.quota += 1;
        }
      }

      allocations.forEach(a => {
        if (a.winWeight <= 0) a.quota = 0;
      });

      const map = {};
      allocations.forEach(a => { map[a.id] = a.quota; });
      return map;
    })();

    return (
      <div className="bg-white p-6 rounded-xl shadow-sm border mb-8">
        <div className="flex flex-wrap justify-between items-center mb-4 gap-4 bg-slate-50 p-4 rounded-xl border">
          <div className="flex items-center gap-2">
            {icon}
            <h2 className="text-xl font-bold text-slate-800">{title}</h2>
          </div>

          <div className="flex items-center gap-3 flex-wrap">
            <div className="flex items-center gap-2 bg-white px-3 py-1.5 rounded-lg border shadow-sm">
              <span className="text-xs font-bold text-slate-500">CYCLE TARGET:</span>
              <input
                type="number"
                min="10"
                className="w-20 text-center font-extrabold text-blue-600 focus:outline-none bg-slate-100 rounded border p-0.5 text-sm"
                value={currentTargetValue}
                onChange={(e) => genderType === 'male' ? setMaleCycleSize(Number(e.target.value)) : setFemaleCycleSize(Number(e.target.value))}
              />
              <span className="text-xs font-bold text-slate-400">Spins</span>
            </div>

            <span className={`text-sm font-bold px-3 py-1.5 rounded-lg border ${isSumOk ? 'bg-green-50 text-green-700 border-green-200' : 'bg-orange-50 text-orange-700 border-orange-200'}`}>
              Sum: {totalPct}% {isSumOk ? '✓' : '(Must be 100%)'}
            </span>

            <button
              onClick={() => handleResetCycle(genderType)}
              className="text-xs bg-amber-50 border border-amber-300 text-amber-700 px-3 py-1.5 rounded-lg flex items-center gap-1 hover:bg-amber-100 transition font-semibold"
            >
              <RotateCcw size={13} /> Reset
            </button>
          </div>
        </div>

        {isComplete && (
          <div className="mb-4 p-3 rounded-lg bg-emerald-50 border border-emerald-300 flex items-center gap-2 text-emerald-700 text-sm font-bold animate-pulse">
            <CheckCircle2 size={16} />
            The complete wins have reached zero! The system will automatically reset the pool on the next spin.
          </div>
        )}

        <div className="overflow-x-auto">
          <table
            className="w-full min-w-[1560px] table-fixed text-left border rounded-lg overflow-hidden"
            style={{ tableLayout: 'fixed' }}
          >
            <colgroup>
              <col style={{ width: '190px' }} />
              <col style={{ width: '130px' }} />
              <col style={{ width: '150px' }} />
              <col style={{ width: '190px' }} />
              <col style={{ width: '300px' }} />
              <col style={{ width: '95px' }} />
              <col style={{ width: '125px' }} />
              <col style={{ width: '230px' }} />
              <col style={{ width: '150px' }} />
            </colgroup>
            <thead className="bg-slate-100 border-b text-sm font-bold text-slate-600">
              <tr>
                <th className="p-3 align-middle leading-tight">Line Item</th>
                <th className="p-3 align-middle leading-tight">Category</th>
                <th className="p-3 align-middle leading-tight">Sub-Category</th>
                {/* Each pool has its own header selector, matching the Mens and Womens layouts. */}
                <th className="p-3 align-middle leading-tight bg-violet-50/70">
                  <div className="flex flex-col gap-1.5">
                    <span>Amount / %</span>
                    <select
                      className="block w-full min-w-0 box-border border border-violet-200 px-2 py-1.5 rounded-lg text-xs font-semibold text-slate-700 bg-white outline-none focus:ring-2 focus:ring-violet-400"
                      value={currentAmountType}
                      onChange={e => handleAmountTypeChange(genderType, e.target.value)}
                      aria-label={`Reward type for ${genderType} line items`}
                      title={`This selection applies only to line items in the ${genderType} table`}
                    >
                      <option value="amount">Amount (PKR)</option>
                      <option value="percentage">Percentage (%)</option>
                    </select>
                  </div>
                </th>
                <th className="p-3 align-middle leading-tight">Label (Wheel Text)</th>
                <th className="p-3 text-center align-middle leading-tight">Status</th>
                <th className="p-3 text-center align-middle leading-tight">Win Weight (%)</th>
                <th className="p-3 text-center align-middle leading-tight">Dynamic Live Progress</th>
                <th className="p-3 text-center align-middle leading-tight border-l border-slate-200 bg-blue-50/50">Fixed Interval (Spins)</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr><td colSpan="9" className="p-8 text-center text-gray-400">Loading configurations...</td></tr>
              ) : rows.length > 0 ? rows.map((p, idx) => {
                const info = getCycleInfo(p.id);
                const dynamicQuotaDisplay = distributedQuotas[p.id] !== undefined ? distributedQuotas[p.id] : 0;

                return (
                  <tr key={p.id} className={`border-b ${idx % 2 === 1 ? 'bg-slate-50' : 'bg-white'} hover:bg-blue-50/40 transition`}>
                    <td className="p-3 align-middle text-gray-700 text-sm break-words">{p.lineItemName}</td>
                    <td className="p-3 align-middle text-gray-500 text-sm break-words">{p.category}</td>
                    <td className="p-3 align-middle text-blue-600 font-semibold text-sm break-words">{p.subCategory}</td>
                    <td className="p-3 align-middle bg-violet-50/30">
                      <div className="flex w-full min-w-0 items-center overflow-hidden rounded-lg border border-violet-200 bg-white focus-within:ring-2 focus-within:ring-violet-400">
                        {currentAmountType === 'amount' && (
                          <span className="shrink-0 border-r border-violet-100 bg-violet-50 px-2 py-2 text-xs font-bold text-violet-700">
                            PKR
                          </span>
                        )}
                        <input
                          type="number"
                          min="0"
                          step="any"
                          className="block w-full min-w-0 box-border border-0 px-2 py-2 text-sm font-semibold text-slate-700 outline-none focus:ring-0"
                          value={p.amount}
                          onChange={e => handleAmountChange(p.id, e.target.value)}
                          aria-label={`Reward value for ${p.lineItemName || p.subCategory}`}
                          placeholder="500"
                          title={currentAmountType === 'percentage' ? 'Enter percentage value; % is shown automatically.' : 'Enter amount; PKR is shown automatically.'}
                        />
                        {currentAmountType === 'percentage' && (
                          <span className="shrink-0 border-l border-violet-100 bg-violet-50 px-2.5 py-2 text-sm font-bold text-violet-700">
                            %
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="p-3 align-middle">
                      <input
                        type="text"
                        className="block w-full min-w-0 box-border border border-slate-300 px-3 py-2.5 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
                        value={p.label}
                        onChange={e => handleLabelChange(p.id, e.target.value)}
                        placeholder="e.g. Fragrance / 10% OFF"
                        aria-label={`Wheel label for ${p.lineItemName || p.subCategory}`}
                      />
                    </td>
                    <td className="p-3 text-center align-middle">
                      <span className={`px-2 py-1 rounded text-[10px] font-bold ${p.isActive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                        {p.isActive ? 'ACTIVE' : 'INACTIVE'}
                      </span>
                    </td>
                    <td className="p-3 align-middle">
                      <div className="flex items-center justify-center gap-1">
                        <input
                          type="number"
                          min="0"
                          max="100"
                          className="border p-2 rounded w-16 font-bold text-center outline-none focus:ring-2 focus:ring-blue-400 text-sm"
                          value={p.winWeight}
                          onChange={e => handleWeightChange(p.id, e.target.value)}
                        />
                        <span className="text-gray-500 font-bold text-sm">%</span>
                      </div>
                    </td>
                    <td className="p-3 text-center align-middle">
                      <div className="flex justify-center">
                        {info ? (
                          <ProgressBar used={info.currentCount} quota={info.quota} />
                        ) : (
                          <span className="text-xs text-indigo-500 font-bold">Target: {dynamicQuotaDisplay} Wins</span>
                        )}
                      </div>
                    </td>
                    <td className="p-3 text-center align-middle border-l border-slate-200">
                      <div className="flex flex-col items-center justify-center gap-1">
                        <input
                          type="number"
                          min="0"
                          className="border p-2 rounded w-16 font-bold text-center text-blue-700 bg-blue-50 outline-none focus:ring-2 focus:ring-blue-400 text-sm"
                          value={p.fixedInterval || 0}
                          onChange={e => handleIntervalChange(p.id, e.target.value)}
                          title="Set the fixed interval in spins"
                        />
                      </div>
                    </td>
                  </tr>
                );
              }) : (
                <tr><td colSpan="9" className="p-8 text-center text-gray-400">No records found.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
          <Save className="text-blue-600" size={24} /> Professional Dynamic Weight Panel
        </h1>
        <button onClick={initialLoad} className="bg-white border px-4 py-2 rounded-lg shadow-sm flex items-center gap-2 hover:bg-gray-50 text-sm">
          <RefreshCw size={16} className={isLoading ? 'animate-spin' : ''} /> Sync Updates
        </button>
      </div>

      <div className="mb-6 p-4 rounded-lg bg-blue-50 border border-blue-200 flex gap-3 items-start">
        <Info size={18} className="text-blue-600 flex-shrink-0 mt-0.5" />
        <div className="text-sm text-blue-800">
          <p className="font-bold mb-0.5">Cyclic process system:</p>
          <ul className="list-disc pl-4 space-y-1 text-xs">
          </ul>
        </div>
      </div>

      {status.msg && (
        <div className={`mb-5 p-4 rounded-lg flex items-center gap-2 text-sm font-semibold ${status.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
          {status.type === 'success' ? <CheckCircle2 size={18} /> : <AlertCircle size={18} />}
          {status.msg}
        </div>
      )}

      {renderTable('male', 'Mens Pool Configuration', <UserCircle size={20} className="text-blue-500" />, maleCycleComplete)}
      {renderTable('female', 'Womens Pool Configuration', <Users size={20} className="text-pink-500" />, femaleCycleComplete)}

      <div className="sticky bottom-6 z-10">
        <button
          onClick={saveProbabilities}
          className="w-full bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white py-4 rounded-xl font-bold shadow-2xl transition-all text-base tracking-wide uppercase"
        >
          💾 Save Configurations
        </button>
      </div>

      {/* Bulk import module */}
      <form onSubmit={handleFileUpload} className="mt-12 bg-white p-6 rounded-xl shadow-sm border max-w-2xl">
        <h2 className="text-lg font-semibold mb-4 flex items-center gap-2 text-green-600">
          <Upload size={18} /> Bulk Import Discount Codes
        </h2>
        <input
          type="file"
          accept=".xlsx,.xls"
          onChange={e => setFile(e.target.files[0])}
          className="mb-4 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:bg-green-50 file:text-green-700 file:font-semibold cursor-pointer"
        />
        <button type="submit" className="w-full bg-green-600 text-white py-3 rounded-lg font-bold hover:bg-green-700 transition">
          Upload Excel file
        </button>
      </form>
    </div>
  );
};

export default AdminDashboard;
